import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  title: {
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '1.5',
    marginBottom: '8px'
  },
  dragContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxHeight: '300px',
    overflow: 'auto'
  }
}));
